module.exports = __webpack_public_path__ + "img/dvojice.a1394abe.svg";